import React from 'react';
import { TotemSelect } from 'components/TotemSelect';
import { SiteState, SiteType, useGetActiveOrganizationsQuery, useGetSitesQuery } from 'data/__generated__';
import { TotemTextArea } from 'components/TotemTextArea';

export type PollAudience = {
    organizationIds: string[];
    siteIds: string[];
    userIds: string[];
};

export const PollAudienceSelector = ({
    audience,
    setAudience,
}: {
    audience: PollAudience;
    setAudience: (audience: PollAudience) => void;
}) => {
    const { data: organizationsData } = useGetActiveOrganizationsQuery();

    const { data: sitesData } = useGetSitesQuery();

    if (!sitesData) {
        return null;
    }

    if (!organizationsData) {
        return null;
    }

    const { activeOrganizations } = organizationsData;

    const organizationOptions = activeOrganizations.map(({ _id, name }) => ({ label: name, value: _id }));

    const { sites } = sitesData;

    const siteOptions = sites
        .filter((site) => site.state !== SiteState.Archived && site.type === SiteType.Microstore)
        .map(({ _id, name }) => ({ label: name, value: _id }));

    return (
        <>
            <TotemSelect
                label="Organisations cibles"
                value={audience.organizationIds}
                options={organizationOptions}
                isMulti
                isClearable
                onChange={(values) => {
                    setAudience({ ...audience, organizationIds: values });
                }}
            />
            <TotemSelect
                label="Sites cibles"
                value={audience.siteIds}
                options={siteOptions}
                isMulti
                isClearable
                onChange={(values) => {
                    setAudience({ ...audience, siteIds: values });
                }}
            />
            <TotemTextArea
                label="Utilisateurs cibles"
                placeholder="Renseignez les identifiants des utilisateurs, séparés par des virgules"
                defaultValue={audience.userIds.join(',')}
                onChange={(value) =>
                    setAudience({
                        ...audience,
                        userIds: value.split(',').map((userId) => userId.replace(' ', '').trim()),
                    })
                }
            />
        </>
    );
};
